import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AppRedirectService } from '../../../services/app-redirect.service';
import { TranslationService } from '../../../services/translation.service';


@Component({
    selector: 'app-app-fallback-redirect',
    standalone: true,
    imports: [],
    templateUrl: './app-fallback-redirect.component.html',
    styleUrl: './app-fallback-redirect.component.scss'
})
export class AppFallbackRedirectComponent implements OnDestroy, AfterViewInit {
    isLoading: boolean = false;
    didHide = false;
    private visibilityHandler!: () => void;
    private timeoutRef: any;

    constructor(
        private readonly _translationService: TranslationService,
        private readonly _appRedirectService: AppRedirectService,
        private readonly _router: Router,
    ) {}

    ngAfterViewInit(): void {
        this.isLoading = true;
        try {
            this._translationService.getCpSecretsFromKeyVault().subscribe((response: any) => {
                if (response) {
                    this._appRedirectService.getSmartBannerLinks();

                    this.isLoading = false;

                    this.didHide = false;

                    this.visibilityHandler = () => {
                        if (document.hidden) {
                            this.didHide = true;
                        }
                    };

                    document.addEventListener('visibilitychange', this.visibilityHandler);

                    // Fallback to App Store if app did NOT open
                    this.timeoutRef = setTimeout(() => {
                        document.removeEventListener('visibilitychange', this.visibilityHandler);

                        if (!this.didHide) {
                            // Replace with your App Store URL
                            this._appRedirectService.redirectUserToStoreBasedOnDeviceRegion();
                            const url: string = localStorage.getItem('routeUrl') ?? '/stories';
                            this._router.navigate([url]);
                        }
                    }, 200);
                }
            });
        } catch {
            // do something
            this.isLoading = false;
        }
    }

    ngOnDestroy(): void {
        document.removeEventListener('visibilitychange', this.visibilityHandler);
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }
    }
}
